var React = require('react');

function CariesRepair (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.6677 12.9997L21.1957 10.5278L12.1677 19.5558M23.6677 12.9997L12.1677 24.4997M23.6677 12.9997L12.1678 1.4998M23.6677 12.9997L22.4316 14.2357M12.1677 24.4997L10.9317 23.2637M12.1677 24.4997L14.6397 22.0278L5.5579 12.946M12.1677 24.4997L0.667816 12.9998M0.667816 12.9998L12.1678 1.4998M0.667816 12.9998L3.13977 15.4717L12.1678 6.44371M0.667816 12.9998L1.9037 11.7638M12.1678 1.4998L13.4038 2.73578M12.1678 1.4998L9.69567 3.9717L18.7774 13.0535M9.16781 12.9998L12.1678 9.99977L15.1678 12.9998L12.1678 15.9998L9.16781 12.9998Z","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CariesRepair.defaultProps = {"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"};

module.exports = CariesRepair;

CariesRepair.default = CariesRepair;
